import { render, staticRenderFns } from "./resourcesDoors.vue?vue&type=template&id=cc2195ea&scoped=true"
import script from "./resourcesDoors.vue?vue&type=script&lang=js"
export * from "./resourcesDoors.vue?vue&type=script&lang=js"
import style0 from "./resourcesDoors.vue?vue&type=style&index=0&id=cc2195ea&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc2195ea",
  null
  
)

export default component.exports